import {
    NATURAL_SEARCH_FETCH_REQUEST,
    NATURAL_SEARCH_FETCH_SUCCESS,
    NATURAL_SEARCH_FETCH_FAILURE,
    NATURAL_SEARCH_NEEDS_CLARIFICATION,
    NATURAL_SEARCH_MARK_APPLIED,
    NATURAL_SEARCH_REHYDRATE,
} from '../actions/actionTypes/natural-search-action-types';
import { CONFIDENCE_NEEDS_CLARIFICATION } from '../utils/naturalSearch';

const INITIAL_STATE = {
    query: '',
    loading: false,
    confidence: null,
    clarificationMessage: null,
    resolvedContext: null,
    error: null,
    // Incremented per applied NL response so URL/type-change listeners can
    // skip their reset paths when the transition originated from NL.
    appliedSentinel: 0,
};

export default function naturalSearchReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case NATURAL_SEARCH_FETCH_REQUEST:
            return {
                ...state,
                query: action.query,
                loading: true,
                error: null,
                // Keep prior confidence/resolvedContext so existing chips stay
                // rendered until the new response lands. Stale clarification
                // messages, however, should clear immediately.
                clarificationMessage: null,
            };

        case NATURAL_SEARCH_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                confidence: action.data.confidence,
                resolvedContext: action.data.resolvedContext,
                clarificationMessage: null,
                error: null,
            };

        case NATURAL_SEARCH_NEEDS_CLARIFICATION:
            return {
                ...state,
                loading: false,
                confidence: CONFIDENCE_NEEDS_CLARIFICATION,
                clarificationMessage: action.data.clarificationMessage,
                error: null,
            };

        case NATURAL_SEARCH_FETCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case NATURAL_SEARCH_MARK_APPLIED:
            return {
                ...state,
                appliedSentinel: state.appliedSentinel + 1,
            };

        case NATURAL_SEARCH_REHYDRATE:
            return {
                ...state,
                query: action.query ?? state.query,
                confidence: action.confidence ?? state.confidence,
                resolvedContext: action.resolvedContext ?? state.resolvedContext,
            };

        default:
            return state;
    }
}
